import anime from "animejs";

export const startLoadingAnimation = (): void => {
  const loadingTimeline = anime.timeline({
    easing: "easeOutCubic",
    loop: true,
  });

  const overlayTimeline = anime.timeline({
    easing: "easeInCubic",
  });

  const containerTimeline = anime.timeline({
    easing: "easeInCubic",
  });

  overlayTimeline.add({
    targets: ".loading-overlay",
    opacity: 1.0,
    duration: 1200,
    complete: function () {
      containerTimeline.add({
        targets: ".svg-container",
        easing: "easeInCubic",
        duration: 500,
        opacity: 1.0,
        scale: [0, 1.0],
        complete: function () {
          loadingTimeline
            .add({
              targets: [".cobra-loading", ".loading-message"],
              easing: "easeInCubic",
              opacity: 1.0,
            })
            .add({
              targets: ".cobra-loading",
              easing: "easeOutCubic",
              delay: 1000,
              opacity: 0,
            })
            .add({
              targets: ".hanging-loading",
              easing: "easeInCubic",
              opacity: 1.0,
            })
            .add({
              targets: [".hanging-loading", ".loading-message"],
              easing: "easeOutCubic",
              delay: 1000,
              opacity: 0,
            })
            .add({
              targets: [".decorative-loading", ".loading-sub-message"],
              easing: "easeInCubic",
              opacity: 1.0,
            })
            .add({
              targets: [".decorative-loading", ".loading-sub-message"],
              easing: "easeOutCubic",
              delay: 1000,
              opacity: 0,
            });
        },
      });
    },
  });
};
